import { render, staticRenderFns } from "./CatalogDetail.vue?vue&type=template&id=6d35e54c&"
import script from "./CatalogDetail.vue?vue&type=script&lang=js&"
export * from "./CatalogDetail.vue?vue&type=script&lang=js&"
import style0 from "./CatalogDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports